import classNames from "classnames";
import React from "react";
import styled from "styled-components";

const SearchToolbarStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .search-bar {
      position: relative;
    }
    .search-input {
      color: #707070;
      font-size: 15px;
      font-weight: 400;
      border: 1px solid #e5e7ef;
      border-radius: 5px;
      background-color: white;
      padding: 6px;
      padding-right: 34px;
    }
    .search-icon {
      position: absolute;
      top: 8px;
      right: 10px;
      color: #707070;
    }
`;
interface SearchToolBarProps {
  className?: string;
  children?: React.ReactNode;
}

const SearchToolBar: React.FC<SearchToolBarProps> = ({ className, ...props }) => {
  const toolbarClass = classNames("common__search_toolbar", className);
  return (
    <SearchToolbarStyle className={toolbarClass}>
      {props.children}
    </SearchToolbarStyle>
  );
};

export default SearchToolBar;
